export enum ToolboxImage {
    Audio = 1,
    NoAudio = 2,
    Video = 3,
    NoVideo = 4,
    Hangup = 5
}